import { requester } from '../utils';

export const getAllPackagesApp = () => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/rsee-package/app`,
                method: 'GET',
                withAuth: false,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("get rsee packages list's error", err);
                reject(err);
            });
    });
};

export const getUserPackages = (data) => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/rsee-package/my-packages`,
                method: 'POST',
                withAuth: true,
                data
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                 console.log("get user packages list's error", err);
                reject(err);
            });
    });
};

export const getUserPackagesTransactions = (data) => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/rsee-package/app/transactions`,
                method: 'POST',
                withAuth: true,
                data,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("get user packages transaction's error", err);
                reject(err);
            });
    });
};

export const buyPackage = (data) => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/rsee-package/buy-package`,
                method: 'POST',
                withAuth: true,
                data,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("buy package's error", err);
                reject(err);
            });
    });
};export const buyRsee = (data) => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/user-rsee/app`,
                method: 'POST',
                withAuth: true,
                data,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("buy rsee's error", err);
                reject(err);
            });
    });
};

